






















import { Component, Mixins, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../system";
import { FixedPhraseReference } from "../../../../../domain/document";

@Component
export default class FixedPhraseEditor extends Mixins(ModelEditableMixin) {
  $refs!: {
    titleInput: HTMLInputElement;
    textarea: HTMLTextAreaElement;
  };
  editingSource: FixedPhraseReference;

  @Emit("dropped")
  dropped(): void {}

  @Emit("selection-changed")
  selectionChanged(selectedText: string): void {}

  mounted(): void {
    if (this.$refs.textarea) {
      document.addEventListener("selectionchange", this.onTextareaSelectionchange);
    }
  }

  beforeDestroy() {
    document.removeEventListener("selectionchange", this.onTextareaSelectionchange, false);
  }

  focusTitle(): void {
    const element = this.$refs.titleInput as HTMLInputElement;
    element.focus();
  }

  getTextareaSelectionStart(): number {
    return this.$refs.textarea.selectionStart;
  }

  getTextareaSelectionEnd(): number {
    return this.$refs.textarea.selectionEnd;
  }

  clearSelection(): void {
    this.$refs.textarea.setSelectionRange(0, 0);
  }

  focusTextarea(): void {
    this.$refs.textarea.focus();
  }

  setTextareaSelectionRange(start: number, end: number): void {
    this.$refs.textarea.setSelectionRange(start, end);
  }

  get title(): string {
    return this.editingSource
      ? this.editingSource.name
      : "";
  }

  set title(value: string) {
    this.writePropertyWhenValid(s => s.name = value);
  }

  get text(): string {
    return this.editingSource
      ? this.editingSource.text
      : "";
  }

  set text(value: string) {
    this.writePropertyWhenValid(s => s.text = value);
  }

  onDrop(event: DragEvent): void {
    event.stopPropagation();
    // ドロップした位置にテキストを挿入してからEmitする
    window.setTimeout(() => {
      this.dropped();
    });    
  }

  onDragOver(event: DragEvent): void {
    event.stopPropagation();
    // キャレットを出したいのと貼り付けはtextareaのデフォルトアクションで行いたいのでpreventDefault()は呼ばない
    event.dataTransfer.dropEffect = "copy";
  }

  onTextareaSelectionchange(event: Event): void {
    if (!this.$refs.textarea) { return; }
    if (!(event.currentTarget instanceof Document)) { return; }

    if (event.currentTarget.activeElement instanceof HTMLTextAreaElement && event.currentTarget.activeElement === this.$refs.textarea) {
      const selectedText = this.text.substring(event.currentTarget.activeElement.selectionStart, event.currentTarget.activeElement.selectionEnd);
      this.selectionChanged(selectedText);
      return;
    }

    if (!(event.currentTarget.activeElement instanceof HTMLTextAreaElement)) {
      this.selectionChanged("");
    }
  }
}
